import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-company-card',
  templateUrl: './account-company-card.component.html',
  styleUrls: ['./account-company-card.component.scss']
})
export class AccountCompanyCardComponent implements OnInit {

  showCounter: boolean;

  constructor() {
    this.showCounter = true;
  }

  ngOnInit() { }

}
